module.exports = __webpack_public_path__ + "static/media/profile.5b48c5fa.svg";